import React from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import JobList from './JobList';
import { useParams, useSearchParams } from 'react-router-dom';

export const MyJobs = () => {
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();

  return (
    <EmployerLayout>
      <div className="flex flex-col w-full">
        <div className="flex-1 flex flex-col gap-8 w-full">
          <JobList
            selectedJobIdFromUrl={jobId}
            highlightedApplicationId={searchParams.get('applicationId')}
          />
        </div>
      </div>
    </EmployerLayout>
  );
};
